import Vue from 'vue/dist/vue.esm.js';

import lang from 'element-ui/lib/locale/lang/pt-br';
import locale from 'element-ui/lib/locale';

import Tooltip from 'element-ui/lib/tooltip';
import Popover from 'element-ui/lib/popover';
import Radio from 'element-ui/lib/radio';
import RadioButton from 'element-ui/lib/radio-button';
import RadioGroup from 'element-ui/lib/radio-group';
import Steps from 'element-ui/lib/steps';
import Step from 'element-ui/lib/step';
import Input from 'element-ui/lib/input';
import Checkbox from 'element-ui/lib/checkbox';
import Button from 'element-ui/lib/button';
import ButtonGroup from 'element-ui/lib/button-group';
import Badge from 'element-ui/lib/badge';
import Form from 'element-ui/lib/form';
import FormItem from 'element-ui/lib/form-item';
import Select from 'element-ui/lib/select';
import Option from 'element-ui/lib/option';
import DatePicker from 'element-ui/lib/date-picker';
import Switch from 'element-ui/lib/switch';
import Slider from 'element-ui/lib/slider';
import Tree from 'element-ui/lib/tree';

import Container from 'element-ui/lib/container';
import Dialog from 'element-ui/lib/dialog';
import Row from 'element-ui/lib/row';
import Col from 'element-ui/lib/col';
import Link from 'element-ui/lib/link';
import Card from 'element-ui/lib/card';
import Dropdown from 'element-ui/lib/dropdown';
import Menu from 'element-ui/lib/menu';
import MenuItem from 'element-ui/lib/menu-item';
import MenuItemGroup from 'element-ui/lib/menu-item-group';
import DropdownMenu from 'element-ui/lib/dropdown-menu';
import DropdownItem from 'element-ui/lib/dropdown-item';
import Submenu from 'element-ui/lib/submenu';
import Collapse from 'element-ui/lib/collapse';
import CollapseItem from 'element-ui/lib/collapse-item';
import Upload from 'element-ui/lib/upload';

import breadcrumb from 'element-ui/lib/breadcrumb';
import breadcrumbItem from 'element-ui/lib/breadcrumb-item';
import Loading from 'element-ui/lib/loading';
import Notification from 'element-ui/lib/notification';
import MessageBox from 'element-ui/lib/message-box';
import Icon from 'element-ui/lib/icon';
import Tabs from 'element-ui/lib/tabs';
import TabPane from 'element-ui/lib/tab-pane';
import Tag from 'element-ui/lib/tag';
import Progress from 'element-ui/lib/progress';
import ColorPicker from 'element-ui/lib/color-picker';
import Alert from 'element-ui/lib/alert';
import Message from 'element-ui/lib/message';
import Statistic from 'element-ui/lib/statistic';

import {
    CheckboxGroup,
    InputNumber,
    Table,
    TableColumn,
    Carousel,
    CarouselItem
} from 'element-ui';
import Pagination from 'element-ui/lib/pagination';
import PageHeader from 'element-ui/lib/page-header';
import Empty from 'element-ui/lib/empty';
import Drawer from 'element-ui/lib/drawer';
import DescriptionsItem from 'element-ui/lib/descriptions-item';
import Divider from 'element-ui/lib/divider';
import PopConfirm from 'element-ui/lib/popconfirm';
import Skeleton from 'element-ui/lib/skeleton';
import SkeletonItem from 'element-ui/lib/skeleton-item';

import Descriptions from 'element-ui/lib/descriptions';
import Timeline from 'element-ui/lib/timeline';
import TimelineItem from 'element-ui/lib/timeline-item';

export default {
    config() {
        locale.use(lang);

        Vue.component(Tooltip.name, Tooltip);
        Vue.component(Popover.name, Popover);
        Vue.component(Radio.name, Radio);
        Vue.component(Skeleton.name, Skeleton);
        Vue.component(SkeletonItem.name, SkeletonItem);
        Vue.component(RadioButton.name, RadioButton);
        Vue.component(RadioGroup.name, RadioGroup);
        Vue.component(Steps.name, Steps);
        Vue.component(Step.name, Step);
        Vue.component(Input.name, Input);
        Vue.component(Checkbox.name, Checkbox);
        Vue.component(CheckboxGroup.name, CheckboxGroup);
        Vue.component(Button.name, Button);
        Vue.component(ButtonGroup.name, ButtonGroup);
        Vue.component(Badge.name, Badge);
        Vue.component(Form.name, Form);
        Vue.component(FormItem.name, FormItem);
        Vue.component(Select.name, Select);
        Vue.component(Option.name, Option);
        Vue.component(DatePicker.name, DatePicker);
        Vue.component(Switch.name, Switch);

        Vue.component(Container.name, Container);
        Vue.component(Dialog.name, Dialog);
        Vue.component(Row.name, Row);
        Vue.component(Col.name, Col);
        Vue.component(Link.name, Link);
        Vue.component(Card.name, Card);
        Vue.component(Dropdown.name, Dropdown);
        Vue.component(Menu.name, Menu);
        Vue.component(MenuItem.name, MenuItem);
        Vue.component(MenuItemGroup.name, MenuItemGroup);
        Vue.component(DropdownItem.name, DropdownItem);
        Vue.component(Submenu.name, Submenu);
        Vue.component(DropdownMenu.name, DropdownMenu);
        Vue.component(Tabs.name, Tabs);
        Vue.component(TabPane.name, TabPane);
        Vue.component(Tag.name, Tag);
        Vue.component(Table.name, Table);
        Vue.component(TableColumn.name, TableColumn);
        Vue.component(Pagination.name, Pagination);
        Vue.component(Collapse.name, Collapse);
        Vue.component(CollapseItem.name, CollapseItem);
        Vue.component(Upload.name, Upload);
        Vue.component(InputNumber.name, InputNumber);
        Vue.component(Drawer.name, Drawer);
        Vue.component(Carousel.name, Carousel);
        Vue.component(CarouselItem.name, CarouselItem);
        Vue.component(Divider.name, Divider);
        Vue.component(PopConfirm.name, PopConfirm);
        Vue.component(Slider.name, Slider);
        Vue.component(Tree.name, Tree);

        Vue.component(PageHeader.name, PageHeader);
        Vue.component(Descriptions.name, Descriptions);
        Vue.component(DescriptionsItem.name, DescriptionsItem);

        Vue.component(Empty.name, Empty);
        Vue.component(breadcrumb.name, breadcrumb);
        Vue.component(breadcrumbItem.name, breadcrumbItem);

        Vue.use(Loading.directive);
        Vue.use(Icon);
        Vue.component(Timeline.name, Timeline);
        Vue.component(TimelineItem.name, TimelineItem);
        Vue.component(Progress.name, Progress);
        Vue.component(ColorPicker.name, ColorPicker);
        Vue.component(Alert.name, Alert);
        Vue.component(Statistic.name, Statistic);
        Vue.prototype.$loading = Loading.service;
        Vue.prototype.$notify = Notification;
        Vue.prototype.$messageBox = MessageBox;
        Vue.prototype.$message = Message;
    }
};
